import { useEffect, useRef } from 'react';

export const useEventListener = (
  eventType: any,
  callback: (e: any) => any,
  element = typeof window !== 'undefined' ? window : null,
  options?: boolean | AddEventListenerOptions,
) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (element == null) {
      return;
    }
    const handler = (e: any) => callbackRef.current(e);
    element.addEventListener(eventType, handler, options);

    return () => element.removeEventListener(eventType, handler, options);
  }, [eventType, element]);
};

/**
 *
 * Use case:
 *
 *  import { useState } from "react"
 *  import useEventListener from "/[path-of-hook]"
 *
 *  const EventListenerComponent = () => {
 *    const [key, setKey] = useState("")
 *    useEventListener("keypress", e => {
 *      setKey(e.key)
 *    })
 *
 *    return <div>Last key pressed: {key}</div>
 *  }
 *
 */
